import axiosInstance from "@/api/axios-instance";

export interface GetInvoicesParams {
  page: number;
  search?: string;
  filter?: string;
}

export const invoiceService = {
  async getInvoices(params: GetInvoicesParams) {
    const { data } = await axiosInstance.get("/invoice", {
      params,
    });
    return data;
  },

  async getInvoiceById(id: string) {
    const { data } = await axiosInstance.get(`/invoice/${id}`);
    return data;
  },
};

export async function fetchInvoicePdf(id: string): Promise<Blob> {
  const { data } = await axiosInstance.get(`/invoice/${id}/pdf`, {
    responseType: "blob",
  });

  return data;
}
